export const lockEl = (self, el) => {
  self._checkNoProcessingTask();
  const locking = self._getLockingThrowable();
  const working_layer = self._getWorkingLayerThrowable();
  el instanceof self._window.SVGGraphicsElement &&
    working_layer.getIsChildGraphicsEl(el) &&
    locking.lockEl(el);
};
